module.exports = __webpack_public_path__ + "static/media/feat-bite-img3.c9f3b928.jpg";